import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
import { PageContentMixin } from '../../mixins/components/PageContentMixin';
import { PageContext } from '../../js/PageContext';
export var StyledPageContent = /*#__PURE__*/styled('div').withConfig({
  shouldForwardProp: doNotForwardTransientProp(['display'])
}).withConfig({
  displayName: "StyledPageContent",
  componentId: "c11n-8-64-0__sc-ney76u-0"
})(["", ""], PageContentMixin);
/**
 * Page content is a generic container that provides a consistent layout
 * for all [`Page`](#/Layout%20components?id=page) components. It sets the max-width and defines
 * default padding and margins.
 *
 * You can use this component with your own custom components to make sure layouts are consistent.
 *
 * See also [`PageTitle`](#pagetitle) and
 * [`PageBreadcrumb`](#/Layout%20components?id=pagebreadcrumb) for more focused components.
 *
 * @since 8.15.0
 */

var PageContent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _React$useContext = React.useContext(PageContext),
      fluid = _React$useContext.fluid;

  return /*#__PURE__*/React.createElement(StyledPageContent, _extends({
    ref: ref,
    fluid: fluid
  }, props));
});
PageContent.displayName = 'PageContent';
PageContent.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * By default, page components will be bound by the `Page.maxWidth` token.
   * Setting this to true will remove the max width bound.
   *
   * Setting this on `Page` will set `fluid` for all child page components.
   */
  fluid: PropTypes.bool
} : {};
/** @component */

export default PageContent;